import { CustomIcon } from 'modules/components/layer00';
import { InformationModalLayout } from 'modules/components/layer13';
import * as ds from './dataService';
import { useTheme } from '@mui/material';

export type RemoveSuperAdminModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: RemoveSuperAdminModalProps) => {
  const [
    fnRemoveSuper,
    { loading }
  ] = ds.useRemoveSuperAdmin();
  const theme = useTheme();

  return (
    <InformationModalLayout.FC
      id={props.id}
      title='Remove user as Super Admin'
      subTitle='This will remove the user from all projects.'
      headerIcon={<CustomIcon.medium.FC icon='BAG' stroke={theme.palette.error.main} />}
      handleClose={props.handleClose}
      loading={loading}
      successButton={{
        handleClick: async () => {
          await fnRemoveSuper(props.id);
          props.handleClose();
        },
        text: 'Remove'
      }}
      isVisible={props.isVisible}
    >

    </InformationModalLayout.FC>
  );

};
